export enum AlertActionNames {
  SHOW_ALERT_ACTION = 'SHOW_ALERT_ACTION',
  REMOVE_ALERT_ACTION = 'REMOVE_ALERT_ACTION',
}
